import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';


const MainMenu = styled('div')(({ theme }) => ({
    width: '100%',
    display:'flex',
    flexDirection:'row',
}));

  const SubMenu = styled('div')(({ theme }) => ({
      width: 'calc(100%)',
      display:'flex',
      flexDirection: 'column',
  }));

  const StyledMenu = styled(Menu)(({ theme }) => ({
    width: 'calc(100%)',
    display:'flex',
    flexDirection: 'row',
    '& ul':{display:'flex',width:'100%'},
    '& .MuiPaper-root':{width:'100%'}
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    justifyContent:'center'
}));


export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };  

  return (
    <MainMenu>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        제품소개
      </Button>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        이용안내
      </Button>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        공지사항
      </Button>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        커뮤니티
      </Button>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        원격지원
      </Button>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        style={{width:'100%'}}
      >
        <SubMenu>
            <StyledMenuItem onClick={handleClose}><a href='/intro'>프로그램</a></StyledMenuItem>
            <StyledMenuItem onClick={handleClose}><a href='/intro'>라이센스</a></StyledMenuItem>
        </SubMenu>
        <SubMenu>
            <StyledMenuItem onClick={handleClose}><a href='/guide'>설치가이드</a></StyledMenuItem>
            <StyledMenuItem onClick={handleClose}><a href='/guide'>레인드롭 가이드</a></StyledMenuItem>
        </SubMenu>
        <SubMenu>
            <StyledMenuItem onClick={handleClose}><a href='/notice'>공지사항</a></StyledMenuItem>
        </SubMenu>
        <SubMenu>
            <StyledMenuItem onClick={handleClose}><a href='/community'>FAQ</a></StyledMenuItem>
            <StyledMenuItem onClick={handleClose}><a href='/community'>문의게시판</a></StyledMenuItem>
            <StyledMenuItem onClick={handleClose}><a href='/community'>버그/오류 신고</a></StyledMenuItem>
            <StyledMenuItem onClick={handleClose}><a href='/community'>자료실</a></StyledMenuItem>
        </SubMenu>
        <SubMenu>
            <StyledMenuItem onClick={handleClose}><a href='/404'>원격지원</a></StyledMenuItem>
        </SubMenu>
      </StyledMenu>
    </MainMenu>
  );
}